import { render, staticRenderFns } from "./CollaborateLabel.vue?vue&type=template&id=061422c8&scoped=true"
import script from "./CollaborateLabel.vue?vue&type=script&lang=js"
export * from "./CollaborateLabel.vue?vue&type=script&lang=js"
import style0 from "./CollaborateLabel.vue?vue&type=style&index=0&id=061422c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061422c8",
  null
  
)

export default component.exports